import React, { Component } from "react";
import Link from "gatsby-link";
import Img from "gatsby-image";
import * as PropTypes from "prop-types";
import Helmet from "react-helmet";
import config from "../../data/SiteConfig";
import Slider from "react-slick";
import MarkdownRenderer from "react-markdown-renderer";
/** Style **/
import styled from "styled-components";
import * as palette from "../layouts/scss/variables";
import { Item, Container, Segment, Grid, Card, Icon } from "semantic-ui-react";

const propTypes = {
  data: PropTypes.object.isRequired
};

const frTelechargement = "Téléchargez la version PDF (version juillet 2021)";
const frRecomtitle = "Ils ont dit...";
const frRecomLink = "Voir le profil de ";
const frDernierArticle = "Dernier article";
const frLireArticle = "Lire l'article";

const Recommandation = styled.article`
  border-top: 2px solid ${palette.DARK_GRAY};
  border-bottom: 2px solid ${palette.DARK_GRAY};
  padding: 20px 0;
  @media (${palette.SM}) {
    padding: 40px;
  }
`;

const BgImage = styled(Img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
  height: 100vh; // or whatever

  // Adjust image positioning (if image covers area with defined height) and add font-family for polyfill
  & > img {
    object-fit: cover !important; // or whatever
    object-position: 0% 0% !important; // or whatever
    font-family: "object-fit: cover !important; object-position: 0% 0% !important;"; // needed for IE9+ polyfill
  }
`;

const AbsoluteContainer = styled(Container)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
`;

const CenterBloc = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  h1 {
    text-shadow: 1px 1px 1px #000;
  }
  svg {
    max-width: 300px;
  }
`;

const Svg = styled.svg`
  max-height: 150px;
  max-width: 150px;
  width: 100%;
  min-width: 150px;
  min-height: 150px;
`;

const LastArticleContainer = styled.article`
  &:hover {
    box-shadow: 0px 0px 10px 2px ${palette.SHADOW};
    border-radius: 0.28571429rem;
    span.ui.button {
      background-color: #cacbcd;
      color: rgba(0, 0, 0, 0.8);
    }
    .ui.cards > .card > .extra,
    .ui.card > .extra {
      box-shadow: 0px -5px 0px 0px #85bee2 inset;
    }
  }
  a {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87) !important;
    &:hover {
      color: rgba(0, 0, 0, 0.87) !important;
    }
  }
`;

const AsideLastArticle = styled.aside`
  h2 {
    line-height: 1;
  }
  .ui.cards > .card,
  .ui.card {
    width: 100%;
  }

  .ui.cards > .card > .extra,
  .ui.card > .extra {
    border-top: none;
    box-shadow: 0px -5px 0px 0px ${palette.TURQUOISE} inset;

    &:hover {
      box-shadow: 0px -5px 0px 0px #85bee2 inset;
    }
  }
`;

class IndexPage extends React.Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      lazyLoad: true,
      adaptiveHeight: true,
      accessibility: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 7000,
      speed: 2000
    };

    const frHomepage = this.props.data.fr.edges[0];

    const bg = this.props.data.bg.edges[0].node.sizes;

    const lastArticle = this.props.data.lastFr.edges[0].node;

    const HOMEPAGE = ({ node }) => (
      <div>
        <Segment
          inverted
          textAlign="center"
          style={{ position: "relative" }}
          vertical
        >
          <BgImage src={bg.src} sizes={bg} aria-hidden="true" />
          <AbsoluteContainer text>
            <CenterBloc>
              <h1>{frHomepage.node.name}</h1>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 362.96 360.96"
              >
                <path
                  fill="none"
                  d="M187.98 1c57.66 0 115.32.04 172.98-.1 3.42-.01 4.1.67 4.09 4.1-.11 117.98-.11 235.97 0 353.96 0 3.42-.67 4.1-4.09 4.1-118.65-.11-237.31-.11-355.96 0-3.42 0-4.1-.67-4.1-4.09.12-118 .12-235.99 0-353.97C.9 1.58 1.57.9 5 .9c56.99.14 113.98.1 170.98.1.34.51.28.97-.17 1.39-4.94 1.84-10.19 1.05-15.28 1.7-35.55 4.54-66.92 18.32-94.04 41.73-32.85 28.35-52.9 64.05-59.42 106.83-6.25 41 .41 80.08 21.68 116.01 28.63 48.36 70.97 77.51 126.4 86.26 41.13 6.5 80.38-.64 116.36-22.2 47.87-28.69 76.71-70.85 85.41-125.89 6.44-40.77-.5-79.74-21.69-115.51-28.64-48.35-71.06-76.9-126.35-86.51-6.87-1.2-13.91-.85-20.73-2.41-.45-.42-.51-.89-.17-1.4z"
                />
                <path
                  fill="#868888"
                  d="M187.98 1a.9.9 0 0 0 .06.95c-4.04 2.39-8.09 2.39-12.13 0 .2-.3.23-.62.06-.95h12.01z"
                />
                <path
                  fill="#444"
                  d="M175.91 1.95h12.13c41.97 1.24 78.71 15.92 110.52 43.15 32.07 27.46 51.97 62.27 58.97 103.59 9.35 55.17-4.12 104.84-40.57 147.7-27.33 32.14-62.18 52.07-103.53 59.11-55.17 9.38-104.83-4.05-147.75-40.43-30.64-25.97-50.3-58.96-58.14-98.15-11.41-57 1.59-108.45 39.24-153.11 25.88-30.7 59.04-49.61 98.06-58.36 10.19-2.28 20.55-3.83 31.07-3.5z"
                />
                <path
                  fill="#add4ec"
                  d="M182.28 8.23c94.33.17 171.68 77.84 171.44 172.17-.23 94.34-77.97 171.63-172.29 171.32-94.15-.31-171.3-77.78-171.2-171.92.1-94.33 77.71-171.73 172.05-171.57z"
                />
                <path
                  fill="#fe5722"
                  d="M65.71 195.96c-.78 3.67-1.59 7.32-2.33 11-.96 4.74-4.43 5.38-8.29 4.77-4.17-.65-4.63-3.93-3.9-7.21a474 474 0 0 0 5.31-26.97c.66-4.06.42-8.16 1.41-12.23.87-3.59-.02-7.53 1.07-11.29.42-1.44.65-3.39-1.02-4.59-1.96-1.4-3.52.12-4.94 1-3.11 1.9-5.96 4.21-8.04 7.26-.56.82-1.06 1.2-1.96.99-1.14-.26-.82-1.27-.91-2.02-.87-7.36 8.56-19.02 15.82-19.57 3.84-.29 7.5 2.82 8.93 7.05 2.12 6.27.44 12.4-.45 18.53-.24 1.64-.56 3.17-.04 5.69 3.34-7.68 5.92-14.92 10.62-21.06 2.93-3.83 5.91-7.73 10.31-9.79 7.15-3.36 13.43.64 13.51 8.6.05 5.08.87 10.25-.82 15.29-.27.82-.37 2.02.87 2.54 3.07-4.92 3.77-10.94 7.27-15.67 3.57-4.83 7.18-9.56 13.38-11.28 4.59-1.27 7.75-.04 10.13 3.93 4.24 7.08 4.51 14.71 3.3 22.59-1.68 10.9-4.47 21.57-6.4 32.42-.44 2.44.25 4.81 2.42 6.12 2.05 1.24 4.27.41 6.07-.89 2.29-1.66 4.19-3.79 6.03-5.94.89-1.04 1.29-3.25 3.22-2.04a4.87 4.87 0 0 1 2.16 4.76c-1.13 8.53-15.79 15.94-23.28 11.82a13.1 13.1 0 0 1-6.58-13.89c1.69-9.22 3.94-18.35 5.44-27.6.79-4.87 1.8-9.74 1.51-14.76-.16-2.89-1.07-5.4-3.63-6.64-2.65-1.28-4.74.57-6.6 2.29a25.06 25.06 0 0 0-6.35 9.44c-5.73 14.83-8.85 30.34-11.45 45.96-.72 4.3-3.12 7.19-6.36 6.85-3.11-.33-5.43-4.02-4.56-8.15 1.53-7.25 3.01-14.5 4.39-21.78 1.75-9.26 2.97-18.59 2.55-28.06-.13-2.89-1.05-5.62-3.7-6.52-2.86-.97-4.91 1.26-6.37 3.62C75.01 164.18 69.4 179 65.5 194.51c-.12.46.08.97.21 1.45zM267.01 171.1c7.78 3.87 9.83 11.38 11.67 18.86.82 3.32.24 7.58 4.12 8.82 5 1.6 9.57-.97 13.01-4.29 2.11-2.04 2.67-1.79 3.96.26 4.14 6.56 4.16 6.53-3.05 10.17a35.85 35.85 0 0 1-14.09 3.99c-5.18.33-8.37-2.27-10.71-6.49-3.4-6.13-4.2-13.03-5.93-19.67-.93-3.58-1.4-7.47-4.67-10.06-1.38-1.1-2.81-.71-4.27-.69-2.07 7.15-1.72 14.73-3.8 21.88a114.5 114.5 0 0 1-3.62 10.31c-4.6 11.59-19.03 10.39-24.96 1.49-7.77-11.64-8.8-24.34-5.42-37.68a50.88 50.88 0 0 1 45.14-38.37c8.59-.75 16.63 1.48 23.42 7.62 10.04 9.09 4.9 22.33-4.17 27.66-5.22 3.08-11.14 3.97-16.63 6.19z"
                />
                <path
                  fill="#444"
                  d="M190.23 263.39c5.09 1.19 9.71-.09 13.94 2.51l-.02-.08h-51.46c4.53-1.83 9.1-1.92 13.67-1.92-.02-2.14-1.62-2.32-2.6-3.04-7.93-5.83-12.46-13.63-13.81-23.36-.4-2.84.08-4.17 3.49-4.13 16.99.17 33.99-.08 50.97.19 4 .06 7.43 2.72 9.86 5.87 1.58 2.05 1.36 4.84.04 7.14-1.43 2.48-3.86 4.2-6.65 3.42-3.37-.94-4.62.65-6.13 3.09-2.62 4.25-6.75 7.11-11.3 10.31zM155.49 91.62c4.28.01 11.04.91 17.69 2.46 8.41 1.96 16.57.15 24.69-1.59 9.36-2 18.5-1.53 27.57 1.38 3.97 1.27 5.15 4.06 2.53 7.32-2.09 2.61-2.99 5.53-3.76 8.58-2.2 8.73-6.13 12.38-14.9 13.61-9.05 1.27-16.76-1.99-20.58-8.94-1.27-2.31-2.06-4.89-3.03-7.36-.8-2.04-1.45-4.17-4.23-4.23-2.93-.07-3.35 2.14-4.02 4.24-4.45 14.1-15.1 19.86-29.02 15.81-4.11-1.2-6.92-3.6-8.48-7.69-2-5.22-2.97-10.79-6.49-15.53-1.88-2.53-1.31-5.63 3.11-6.39 5.43-.94 10.86-1.58 18.92-1.67z"
                />
                <path
                  fill="#fe6d3f"
                  d="M65.71 195.96c-1.66-1.96-.23-3.84.27-5.65 3.89-13.98 9.07-27.42 16.71-39.84 1.69-2.75 3.9-5.1 7.17-4.21 3.53.97 4.05 4.33 4.18 7.7.63 16.43-3.43 32.2-6.63 48.08-.79 3.91-.43 7.14 3.57 8.63 2.82 1.05 5.21-2.23 6.04-6.92 2.71-15.34 5.64-30.65 11.29-45.25a26.82 26.82 0 0 1 6.56-9.9c2.04-1.93 4.44-3.4 7.19-2.34 2.94 1.13 3.83 3.88 3.95 6.92.29 7.35-1.29 14.5-2.53 21.66-1.24 7.17-3.01 14.24-4.32 21.39-.93 5.05 1.04 9.25 5.06 12.24 4.28 3.19 8.83 3.36 13.46.37a32.75 32.75 0 0 0 9.41-9.46c1.49-2.2.58-4.17-.9-5.31-2.02-1.55-2.04 1.28-2.96 2.11-1.72 1.57-3.21 3.4-4.98 4.9-2.31 1.95-5.21 2.87-7.87 1.32-2.56-1.49-2.8-4.43-2.27-7.16 1.72-8.76 3.62-17.49 5.32-26.25 1.65-8.51 2.67-16.86-1.01-25.35-3.55-8.19-10.24-8.08-16.52-3.03-5.99 4.82-9.75 11.18-12.13 18.45-.58 1.77-.51 4.13-2.92 4.88 2.72-8.87 5.96-17.37 13.31-23.72a16.64 16.64 0 0 1 9.75-4.19c3.83-.34 6.45 1.26 8.46 4.73 5.3 9.18 3.93 18.87 2.32 28.46-1.48 8.86-3.72 17.6-5.6 26.4a5.61 5.61 0 0 0 2 5.8c2.04 1.57 4.24.25 5.89-1.06 3.51-2.77 6.18-6.4 8.91-10.05 4.39 6.49 4.32 8.32-.4 13.58-2.44 2.72-5.05 5.38-8.4 6.86-4.83 2.14-9.77 1.87-14.06-1.39-4.53-3.43-5.89-8.41-4.94-13.77 1.65-9.35 3.93-18.59 5.47-27.96.77-4.68 1.86-9.4 1.44-14.25-.23-2.67-1.22-5.06-3.61-6.09-2.2-.94-4 .83-5.6 2.31a25.46 25.46 0 0 0-6.52 9.81c-5.57 14.79-8.77 30.19-11.28 45.74-.75 4.65-2.85 7.08-6.85 6.77-4.68-.36-5.68-3.67-5.08-7.43 1.23-7.76 2.83-15.47 4.31-23.19 1.73-9.09 2.98-18.22 2.65-27.51-.1-2.89-1.12-5.81-3.69-6.44-2.33-.57-4.18 1.73-5.6 4.03-8.55 13.85-14.02 28.91-18.02 44.58z"
                />
                <path
                  fill="#fe6c3e"
                  d="M267.01 171.1c1.88-2.66 5.04-2.2 7.64-3.04 5.81-1.86 11.27-4.3 14.87-9.42 6.59-9.36 2.24-21.22-9.28-25.71-15.12-5.88-29.06-2.11-41.25 6.93-14.12 10.48-21.66 25.24-20.81 43.08.48 10.08 2.27 20.36 11.89 26.65 7.07 4.62 14.59 2.59 18.48-4.78 4.11-7.78 5.4-16.3 6.38-24.88.32-2.78.45-5.56 2.14-7.94-1.28 11.07-2.44 22.02-6.81 32.61-4.85 11.74-20.27 10.52-26.16 1.54-7.8-11.91-9.1-24.95-5.37-38.36 6.18-22.17 21.05-35.19 43.7-38.56 9.48-1.41 18.5.73 26.1 7.7 9.34 8.57 5.8 22.57-4.36 28.4a48.3 48.3 0 0 1-17.16 5.78z"
                />
                <path
                  fill="#add4ec"
                  d="M253.95 149.94l-2.01 1.96c-2.13 3.01-1.82 6.76-3.07 10.04-1 .04-2.02-.05-2.98.15-1.61.33-3.89-1.12-4.7 1.35a4.34 4.34 0 0 0 2.48 5.42c5.17 2.3 4.48 5.81 3.71 10.44-.71 4.3-.62 8.88-1.49 13.2-.72 3.59-2.59 6.94-3.94 10.4-4.67 2.4-8.91.53-11.82-5.24-3.14-6.21-3.16-12.96-2.52-19.55 1.02-10.42 4.37-20.09 11.57-28.06 5.89-6.53 13.1-10.61 21.9-11.5 3.3-.33 6.67-.21 9.99-.02 7.14.4 12.86 6.16 12.36 12.36-.39 4.89-3.82 7.68-7.63 9.78a22.5 22.5 0 0 1-16.81 2.23l.06.05c-1.2-2.41-.25-4.71.22-7.08.92-4.64-.47-6.1-5.32-5.93z"
                />
                <path
                  fill="#fe693a"
                  d="M258.99 162.91c4.98.39 9.81.02 14.57-1.84 5.83-2.29 10.13-7.7 9.41-12.48-.7-4.63-6.57-9.14-12.44-9.63-23.56-1.96-37.46 13.46-41.55 34.06-1.52 7.67-1.79 15.34.99 22.87 2.2 5.95 6.57 8.56 11.98 7.03-2.58 3.87-5.5 2.06-8.13.26-4.28-2.93-6.14-7.56-6.63-12.37-1.6-15.78 1.31-30.64 12.4-42.54 9.38-10.06 21.84-12.07 34.87-9.78 4.47.78 8.19 4.02 9.35 8.81 1.16 4.79-.6 8.79-4.49 11.86-6.13 4.81-12.84 6.35-20.33 3.75z"
                />
                <path
                  fill="#fe6c3e"
                  d="M253.95 149.94c5.03-1.69 5.78-1.11 6.05 3.77.17 3.17-1.77 6.05-.95 9.24-1.88-1.58-1.49-3.92-.86-5.53 1.75-4.53.11-6.65-4.24-7.48z"
                />
                <path
                  fill="#fe6f42"
                  d="M248.87 161.95c.33-3.56-.07-7.34 3.07-10.04-1.06 3.33-.98 7.02-3.07 10.04z"
                />
                <path
                  fill="#b4d2e1"
                  d="M213.01 243.12c-.17 2.67-1.66 4.58-4.79 4.8-1.23.09-3.35-.21-2.43-1.9 1.39-2.58-.28-6.94 3.5-7.73 1.9-.4 3.62 1.95 3.72 4.83z"
                />
                <path
                  fill="#add4ec"
                  d="M155.69 121.13c-10.49.05-18.56-11.16-15.29-21.2a5.78 5.78 0 0 1 4.5-4.17c8.02-1.76 16.08-2.53 24.08-.03 5.85 1.83 7.16 4.71 5.33 10.68-3.08 10.08-8.89 14.67-18.62 14.72zM208.25 121.13c-11.6-.02-18.73-6.16-20.32-16.26-.69-4.38.59-7.58 5.1-8.88 7.98-2.31 16-2.68 24.1-.49 4.06 1.1 5.95 3.73 5.23 7.75-1.23 6.9-1.08 14.78-10.06 17.16-1.74.47-3.57.64-4.05.72z"
                />
                <path fill="none" d="M107.24 105.46l70.71-70.71" />
                <path
                  fill="none"
                  stroke="#000"
                  strokeMiterlimit="10"
                  strokeWidth="4"
                  d="M182.44 180.48"
                />
                <g>
                  <path
                    fill="#444"
                    d="M108.68 104.08l142.56 148.76-2.89 2.77L105.8 106.85z"
                  />
                </g>
                <g>
                  <path
                    fill="#444"
                    d="M248.96 104.07l2.89 2.77-142.77 148.77-2.89-2.77z"
                  />
                </g>
              </svg>
            </CenterBloc>
          </AbsoluteContainer>
        </Segment>

        <Container>
          <Grid stackable columns={2}>
            <Grid.Column width={11}>
              <MarkdownRenderer
                markdown={frHomepage.node.content.content}
                style={{ marginBottom: 10 }}
              />
              <a
                href={require("../static/files/CV_Massimo_RUSSO.pdf")}
                target={"_blank"}
                title={"CV Massimo Russo - PDF"}
                className={"ext-pdf"}
              >
                {frTelechargement}
              </a>
            </Grid.Column>
            <Grid.Column width={5}>
              <LASTARTICLE />
            </Grid.Column>
          </Grid>
        </Container>

        <Container fluid style={{ backgroundColor: `${palette.SHADOW}` }}>
          <Container>
            <Grid>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M108.4 0h23v22.8h21.2V0h23v69h-23V46h-21v23h-23.2M206 23h-20.3V0h63.7v23H229v46h-23m53.5-69h24.1l14.8 24.3L313.2 0h24.1v69h-23V34.8l-16.1 24.8-16.1-24.8V69h-22.6m89.2-69h23v46.2h32.6V69h-55.6" />
                  <path
                    fill="#e44d26"
                    d="M107.6 471l-33-370.4h362.8l-33 370.2L255.7 512"
                  />
                  <path fill="#f16529" d="M256 480.5V131h148.3L376 447" />
                  <path
                    fill="#ebebeb"
                    d="M142 176.3h114v45.4h-64.2l4.2 46.5h60v45.3H154.4m2 22.8H202l3.2 36.3 50.8 13.6v47.4l-93.2-26"
                  />
                  <path
                    fill="#fff"
                    d="M369.6 176.3H255.8v45.4h109.6m-4.1 46.5H255.8v45.4h56l-5.3 59-50.7 13.6v47.2l93-25.8"
                  />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 512">
                  <path
                    fill="#264de4"
                    d="M362.74 100.62l-33.05 370.2L181.15 512 33 470.88 0 100.62z"
                  />
                  <path
                    fill="#2965f1"
                    d="M301.4 447.25l28.24-316.36H181.37v349.63z"
                  />
                  <path
                    fill="#ebebeb"
                    d="M75.68 268.22l4.07 45.41h101.62v-45.41zM181.37 176.31H67.5l4.13 45.41h109.74zM181.37 433.4v-47.25l-.2.06-50.57-13.66-3.24-36.22H81.78l6.36 71.3 93.02 25.83z"
                  />
                  <path d="M85.37 0h55v23h-32v23h32v23h-55zM151.37 0h55v20h-32v4h32v46h-55V49h32v-4h-32zM217.37 0h55v20h-32v4h32v46h-55V49h32v-4h-32z" />
                  <path
                    fill="#fff"
                    d="M237.13 313.63l-5.27 58.89-50.65 13.67v47.25l93.1-25.81.68-7.67 10.67-119.55 1.1-12.19 8.2-91.91H181.22v45.41h63.99l-4.13 46.5H181.2v45.41z"
                  />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 630 630">
                  <path fill="#f7df1e" d="M0 0h630v630H0z" />
                  <path d="M423.2 492.19c12.69 20.72 29.2 35.95 58.4 35.95 24.53 0 40.2-12.26 40.2-29.2 0-20.3-16.1-27.49-43.1-39.3l-14.8-6.35c-42.72-18.2-71.1-41-71.1-89.2 0-44.4 33.83-78.2 86.7-78.2 37.64 0 64.7 13.1 84.2 47.4l-46.1 29.6c-10.15-18.2-21.1-25.37-38.1-25.37-17.34 0-28.33 11-28.33 25.37 0 17.76 11 24.95 36.4 35.95l14.8 6.34c50.3 21.57 78.7 43.56 78.7 93 0 53.3-41.87 82.5-98.1 82.5-54.98 0-90.5-26.2-107.88-60.54zm-209.13 5.13c9.3 16.5 17.76 30.45 38.1 30.45 19.45 0 31.72-7.61 31.72-37.2v-201.3h59.2v202.1c0 61.3-35.94 89.2-88.4 89.2-47.4 0-74.85-24.53-88.81-54.08z" />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 256 256">
                  <defs />
                  <path fill="#007ACC" d="M0 128v128h256V0H0z" />
                  <path fill="#FFF" d="M56.611 128.85l-.081 10.483h33.32v94.68H113.42v-94.68h33.32v-10.28c0-5.69-.122-10.444-.284-10.566-.122-.162-20.399-.244-44.983-.203l-44.739.122-.122 10.443zM206.567 118.108c6.501 1.626 11.459 4.51 16.01 9.224 2.357 2.52 5.851 7.112 6.136 8.209.08.325-11.053 7.802-17.798 11.987-.244.163-1.22-.894-2.317-2.52-3.291-4.794-6.745-6.867-12.028-7.232-7.76-.529-12.759 3.535-12.718 10.32 0 1.992.284 3.17 1.097 4.796 1.707 3.535 4.876 5.648 14.832 9.955 18.326 7.884 26.168 13.085 31.045 20.48 5.445 8.25 6.664 21.415 2.966 31.208-4.063 10.646-14.14 17.88-28.323 20.277-4.388.772-14.79.65-19.504-.203-10.28-1.829-20.033-6.908-26.047-13.572-2.357-2.601-6.949-9.387-6.664-9.875.122-.162 1.178-.812 2.356-1.503 1.138-.65 5.446-3.13 9.509-5.486l7.355-4.267 1.544 2.276c2.154 3.291 6.867 7.802 9.712 9.305 8.167 4.308 19.383 3.698 24.909-1.26 2.357-2.153 3.332-4.388 3.332-7.68 0-2.966-.366-4.266-1.91-6.5-1.99-2.845-6.054-5.243-17.595-10.24-13.206-5.69-18.895-9.225-24.096-14.833-3.007-3.25-5.852-8.452-7.03-12.8-.975-3.616-1.22-12.678-.447-16.335 2.723-12.76 12.353-21.658 26.25-24.3 4.51-.853 14.994-.528 19.424.57z" />
                </Svg>
              </Grid.Column>


              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 261.76 226.69"
                >
                  <path
                    fill="#41b883"
                    d="M161.1 0l-30.23 52.35L100.65 0H0L130.87 226.7 261.75 0z"
                  />
                  <path
                    fill="#34495e"
                    d="M161.1 0l-30.23 52.35L100.65 0h-48.3l78.52 136.01L209.4.01z"
                  />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" class="NuxtLogo" viewBox="0 0 452 342">
                  <defs />
                  <path fill="#00C58E" d="M139 330l-1-2c-2-4-2-8-1-13H29L189 31l67 121 22-16-67-121c-1-2-9-14-22-14-6 0-15 2-22 15L5 303c-1 3-8 16-2 27 4 6 10 12 24 12h136c-14 0-21-6-24-12z" />
                  <path fill="#108775" d="M447 304L317 70c-2-2-9-15-22-15-6 0-15 3-22 15l-17 28v54l39-67 129 230h-49a23 23 0 01-2 14l-1 1c-6 11-21 12-23 12h76c3 0 17-1 24-12 3-5 5-14-2-26z" />
                  <path fill="#2F495E" d="M376 330v-1l1-2c1-4 2-8 1-12l-4-12-102-178-15-27h-1l-15 27-102 178-4 12a24 24 0 002 15c4 6 10 12 24 12h190c3 0 18-1 25-12zM256 152l93 163H163l93-163z" />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg
                  xmlns="http://www.w3.org/2000/svg"
                  data-name="Layer 1"
                  viewBox="0 0 23 20.46"
                >
                  <path
                    fill="#61dafb"
                    d="M18.91 6.63l-.74-.23.11-.5c.57-2.73.2-4.92-1.05-5.64-1.2-.7-3.16.03-5.15 1.75l-.57.53-.38-.35C9.05.34 6.97-.43 5.73.29c-1.2.7-1.56 2.75-1.06 5.33l.17.77c-.3.08-.58.17-.85.26C1.56 7.5 0 8.83 0 10.21c0 1.43 1.67 2.86 4.2 3.72l.63.2q-.1.4-.18.82c-.48 2.53-.1 4.55 1.09 5.23 1.23.72 3.3-.02 5.32-1.78q.24-.2.48-.44.3.3.62.57c1.96 1.68 3.89 2.36 5.08 1.67 1.24-.72 1.64-2.88 1.12-5.5l-.14-.62.43-.14c2.63-.87 4.35-2.28 4.35-3.73 0-1.38-1.6-2.72-4.09-3.58zm-6.18-3.87c1.7-1.48 3.28-2.07 4-1.65.78.45 1.08 2.24.6 4.59l-.11.45a23.54 23.54 0 0 0-3.08-.48 23.08 23.08 0 0 0-1.94-2.43q.26-.25.53-.48zm-5.94 8.63q.31.6.65 1.2.35.59.73 1.17a20.92 20.92 0 0 1-2.12-.34c.2-.65.45-1.34.74-2.03zm0-2.31c-.29-.68-.53-1.35-.73-1.99.66-.15 1.36-.27 2.08-.36q-.36.57-.7 1.16-.34.59-.65 1.19zm.52 1.16q.46-.95.98-1.86.52-.9 1.12-1.77a27.84 27.84 0 0 1 4.19 0q.58.86 1.1 1.77.53.9 1 1.84-.46.95-.99 1.86-.52.91-1.1 1.78a29.62 29.62 0 0 1-4.2.01Q8.83 13 8.3 12.1q-.52-.9-.98-1.85zm8.25 2.33q.35-.6.67-1.21a20.87 20.87 0 0 1 .77 2.02 20.85 20.85 0 0 1-2.15.36q.37-.57.71-1.17zm.66-3.49l-.66-1.2q-.34-.58-.7-1.15c.73.1 1.43.22 2.1.37a20.96 20.96 0 0 1-.74 1.98zm-4.7-5.14a21.01 21.01 0 0 1 1.34 1.64q-1.35-.07-2.71 0c.44-.6.9-1.14 1.36-1.64zm-5.3-2.8c.76-.44 2.46.2 4.26 1.78l.34.32a23.55 23.55 0 0 0-1.96 2.43 24 24 0 0 0-3.07.47l-.15-.7c-.44-2.21-.15-3.88.57-4.3zM5.08 13.18L4.52 13a8.32 8.32 0 0 1-2.68-1.42 2.03 2.03 0 0 1-.86-1.37c0-.84 1.25-1.9 3.33-2.63q.4-.14.8-.25a23.56 23.56 0 0 0 1.12 2.9 23.92 23.92 0 0 0-1.14 2.95zm5.33 4.48a8.32 8.32 0 0 1-2.58 1.61 2.03 2.03 0 0 1-1.61.06c-.73-.41-1.03-2.03-.62-4.2l.17-.76a23.1 23.1 0 0 0 3.1.45 23.91 23.91 0 0 0 1.97 2.44l-.43.4zm1.12-1.11c-.47-.5-.93-1.06-1.39-1.66q.66.03 1.35.03.7 0 1.39-.03a20.9 20.9 0 0 1-1.35 1.66zm5.96 1.37a2.03 2.03 0 0 1-.75 1.43c-.72.41-2.27-.13-3.94-1.57q-.3-.25-.58-.53a23.09 23.09 0 0 0 1.92-2.44 22.94 22.94 0 0 0 3.12-.48l.12.55a8.32 8.32 0 0 1 .11 3.04zm.84-4.91l-.39.12a23.06 23.06 0 0 0-1.16-2.91 23.05 23.05 0 0 0 1.12-2.87c.23.06.46.14.68.21 2.13.73 3.43 1.82 3.43 2.65 0 .9-1.4 2.05-3.68 2.8z"
                  />
                  <path
                    fill="#61dafb"
                    d="M11.5 8.16a2.05 2.05 0 1 1-2.05 2.05 2.05 2.05 0 0 1 2.05-2.05"
                  />
                </Svg>
              </Grid.Column>


              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 250 260"
                  preserveAspectRatio="xMidYMid"
                >
                  <path
                    fill="#744C9E"
                    d="M128 0C57.3 0 0 57.3 0 128s57.3 128 128 128 128-57.3 128-128S198.7 0 128 0zM27.5 129.33l99.17 99.17c-54.46-.71-98.46-44.71-99.17-99.17zm123 96.65L30.02 105.5C40.23 60.82 80.22 27.5 128 27.5c33.4 0 62.98 16.29 81.26 41.36l-13.91 12.28a82.08 82.08 0 0 0-144.51 18.94l105.1 105.1a82.22 82.22 0 0 0 51.73-57.48H164.1V128h64.41c0 47.78-33.33 87.77-78.01 97.98z"
                  />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250">
                  <defs />
                  <path fill="#dd0031" d="M125 30L31.9 63.2l14.2 123.1L125 230l78.9-43.7 14.2-123.1z" />
                  <path fill="#c3002f" d="M125 30v22.2-.1V230l78.9-43.7 14.2-123.1L125 30z" />
                  <path fill="#fff" d="M125 52.1L66.8 182.6h21.7l11.7-29.2h49.4l11.7 29.2H183L125 52.1zm17 83.3h-34l17-40.9 17 40.9z" />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                  <g fill="#E11F27">
                    <path d="M248.22 3.26C112.1 3.26 2 114.44 2 251.11s110.1 247.85 246.22 247.85c136.13 0 246.22-110.64 246.22-247.85 0-136.67-110.1-247.85-246.22-247.85zm2.17 427.37c-99.25 0-180.06-81.36-180.06-181.15S151.14 68.34 250.4 68.34s180.06 81.35 180.06 181.14c0 100.33-80.27 181.15-180.06 181.15z" />
                    <path d="M83.35 295.58s29.29 115.52 144.8 127.45c115.52 12.48 173.01-87.86 173.01-87.86l-30.91-18.98S321.98 397 236.29 394.3c-85.69-2.72-128.53-54.24-152.94-98.7z" />
                    <path d="M144.1 360.66c26.02 18.44 56.4 28.2 92.19 29.29 81.9 2.71 129.62-75.39 130.16-75.93l2.17-3.8 3.8 2.17 28.74 17.9c26.57-43.39 20.07-92.2 20.07-92.2l-53.7.55s4.34 78.63-90.56 123.65c-39.6 18.44-105.76 15.73-145.35-15.73.54 0 4.34 5.97 12.47 14.1z" />
                    <path d="M360.49 234.3v-4.34h4.33l56.4-.54c-2.7-43.4-35.24-81.9-35.24-81.9l-62.92 39.05s40.14 29.83 3.8 100.88c-12.47 24.94-40.13 51.52-65.08 62.9-30.37 14.1-54.23 15.2-54.23 15.2 3.25 1.08 32.54 7.04 74.3-11.4 81.35-35.79 78.63-116.6 78.63-119.85z" />
                  </g>
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" viewBox="592.7 141.9 368 368">
                  <defs />
                  <path fill="#3544b1" d="M602.2 325.7c.1-96.4 78.4-174.4 174.7-174.3s174.4 78.4 174.3 174.7c-.1 96.4-78.2 174.3-174.5 174.3-96.5-.1-174.6-78.3-174.5-174.7zm170.9 59.7c-13.5.4-27.1-.8-40.3-3.6-9.8-2-18-8.6-22-17.7-3.9-9.1-5.9-23.1-5.7-42.1.1-9.9.7-19.8 1.9-29.7 1.1-9.6 2.3-17.5 3.4-23.7l1.2-6.2v-.5c0-1.7-1.2-3.2-2.9-3.5l-22.5-3.5h-.5c-1.6 0-3.1 1.1-3.4 2.7-.4 1.4-.6 2.5-1.3 5.9-1.3 6.6-2.5 13.1-3.8 22.5-1.4 10.2-2.2 20.5-2.5 30.9-.5 7.2-.5 14.4 0 21.6.5 19.1 3.8 34.3 9.8 45.8 6 11.4 16.2 19.6 30.6 24.6 14.4 5 34.4 7.5 60.1 7.4h3.2c25.7.1 45.8-2.4 60.1-7.4 14.4-5 24.6-13.2 30.6-24.6 6-11.4 9.3-26.7 9.8-45.8.5-7.2.5-14.4 0-21.6-.3-10.3-1.2-20.6-2.5-30.9-1.3-9.3-2.5-15.7-3.8-22.5-.7-3.4-.9-4.5-1.3-5.9-.4-1.6-1.8-2.7-3.4-2.7h-.6l-22.5 3.5c-1.7.3-3 1.8-3 3.5v.5l1.2 6.2c1.1 6.2 2.3 14.1 3.4 23.7 1.2 9.8 1.8 19.7 1.8 29.7.2 18.9-1.7 33-5.7 42.1-4 9.1-12.2 15.7-21.9 17.8-13.2 2.8-26.8 4-40.3 3.6l-7.2-.1z" />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080"><defs /><rect width="100%" height="100%" fill="transparent" /><rect width="1080" height="1080" x="-540" y="-540" fill="#fff" rx="0" ry="0" transform="translate(540 540)" vector-effect="non-scaling-stroke" /><g><path fill="#f05a22" d="M1079.987.113v1079.874H.113V.113h1079.874zM539.76 460.433c-43.934 0-79.848 35.973-79.848 79.908 0 32.485 19.352 61.6 49.048 73.572 29.638 12.553 63.867 5.695 86.706-17.144 22.78-22.78 29.638-57.01 17.086-86.706-11.39-30.22-40.506-49.63-72.992-49.63m205.375 24.583c-68.458 0-66.773 109.487.523 109.487h122.679c69.562 0 58.172-82.696 54.162-104.373-.523-2.848-3.428-5.114-6.276-5.114H745.134M334.966 594.503c68.458 0 66.715-109.487-.581-109.487H211.764c-69.62 0-58.23 82.696-54.22 104.373.58 2.847 3.428 5.114 6.276 5.114h171.146m310.91-238.442c-47.944 47.944 30.219 124.364 78.105 77.001 8.717-8.659 78.047-78.047 86.706-86.706 49.106-49.048-17.086-99.84-35.333-111.811-2.848-1.686-6.277-1.686-8.543.58L645.876 356.062M433.643 723.458c47.944-47.944-30.219-124.364-78.163-77.06-8.66 8.718-77.99 78.048-86.706 86.707-49.048 49.106 17.143 99.258 35.391 111.811 2.848 1.743 6.277 1.162 8.543-.523l120.935-120.935m51.373-389.073c0 68.458 109.487 66.773 109.487-.582v-122.62c0-69.62-82.696-58.172-104.373-54.22-2.848.58-5.114 3.428-5.114 6.276v171.146m109.487 410.75c0-68.459-109.487-66.774-109.487.522v122.679c0 69.562 82.696 58.172 104.373 54.162 2.847-.523 5.114-3.428 5.114-6.276V745.134M356.06 433.644c47.944 48.466 124.364-30.22 77.001-78.164-8.659-8.66-78.047-77.99-86.706-86.706-49.048-49.048-99.84 17.143-111.811 35.391-1.686 2.848-1.686 6.277.58 7.962 8.079 8.136 48.41 48.641 120.936 121.516m367.397 212.233c-47.944-48.526-124.364 30.219-77.06 78.105l86.707 86.706c49.106 49.106 99.84-17.086 111.811-35.333 1.743-2.848 1.743-6.277-.523-8.02-8.078-8.078-48.409-48.583-120.935-121.458" vector-effect="non-scaling-stroke" /><path fill="none" d="M1079.987.113v1079.874H.113V.113h1079.874zM539.76 460.433c-43.934 0-79.848 35.973-79.848 79.908 0 32.485 19.352 61.6 49.048 73.572 29.638 12.553 63.867 5.695 86.706-17.144 22.78-22.78 29.638-57.01 17.086-86.706-11.39-30.22-40.506-49.63-72.992-49.63m205.375 24.583c-68.458 0-66.773 109.487.523 109.487h122.679c69.562 0 58.172-82.696 54.162-104.373-.523-2.848-3.428-5.114-6.276-5.114H745.134M334.966 594.503c68.458 0 66.715-109.487-.581-109.487H211.764c-69.62 0-58.23 82.696-54.22 104.373.58 2.847 3.428 5.114 6.276 5.114h171.146m310.91-238.442c-47.944 47.944 30.219 124.364 78.105 77.001 8.717-8.659 78.047-78.047 86.706-86.706 49.106-49.048-17.086-99.84-35.333-111.811-2.848-1.686-6.277-1.686-8.543.58L645.876 356.062M433.643 723.458c47.944-47.944-30.219-124.364-78.163-77.06-8.66 8.718-77.99 78.048-86.706 86.707-49.048 49.106 17.143 99.258 35.391 111.811 2.848 1.743 6.277 1.162 8.543-.523l120.935-120.935m51.373-389.073c0 68.458 109.487 66.773 109.487-.582v-122.62c0-69.62-82.696-58.172-104.373-54.22-2.848.58-5.114 3.428-5.114 6.276v171.146m109.487 410.75c0-68.459-109.487-66.774-109.487.522v122.679c0 69.562 82.696 58.172 104.373 54.162 2.847-.523 5.114-3.428 5.114-6.276V745.134M356.06 433.644c47.944 48.466 124.364-30.22 77.001-78.164-8.659-8.66-78.047-77.99-86.706-86.706-49.048-49.048-99.84 17.143-111.811 35.391-1.686 2.848-1.686 6.277.58 7.962 8.079 8.136 48.41 48.641 120.936 121.516m367.397 212.233c-47.944-48.526-124.364 30.219-77.06 78.105l86.707 86.706c49.106 49.106 99.84-17.086 111.811-35.333 1.743-2.848 1.743-6.277-.523-8.02-8.078-8.078-48.409-48.583-120.935-121.458" vector-effect="non-scaling-stroke" /></g></Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 547.8 410.6"
                >
                  <path
                    fill="#CD6799"
                    d="M471.4 236c-19.1.1-35.7 4.7-49.6 11.5-5.1-10.1-10.2-19.1-11.1-25.7-1-7.7-2.2-12.4-1-21.6 1.2-9.2 6.6-22.3 6.5-23.3s-1.2-5.7-12.2-5.8c-11-.1-20.5 2.1-21.6 5-1.1 2.9-3.2 9.5-4.6 16.3-1.9 10-22 45.7-33.5 64.4-3.7-7.3-6.9-13.7-7.6-18.8-1-7.7-2.2-12.4-1-21.6 1.2-9.2 6.6-22.3 6.5-23.3-.1-1-1.2-5.7-12.2-5.8-11-.1-20.5 2.1-21.6 5-1.1 2.9-2.3 9.7-4.6 16.3-2.3 6.6-29 66.2-36 81.6-3.6 7.9-6.7 14.2-8.9 18.5s-.1.3-.4.8c-1.9 3.7-3 5.7-3 5.7v.1c-1.5 2.7-3.1 5.2-3.9 5.2-.6 0-1.7-7.2.2-17 4-20.7 13.5-52.9 13.4-54 0-.6 1.8-6.2-6.2-9.1-7.8-2.9-10.6 1.9-11.3 1.9-.7 0-1.2 1.7-1.2 1.7s8.7-36.2-16.6-36.2c-15.8 0-37.6 17.3-48.4 32.9-6.8 3.7-21.3 11.6-36.8 20.1-5.9 3.3-12 6.6-17.7 9.7-.4-.4-.8-.9-1.2-1.3-30.6-32.7-87.2-55.8-84.8-99.7.9-16 6.4-58 108.7-109 84.2-41.5 151.2-30 162.8-4.5 16.6 36.4-35.9 104-122.9 113.8-33.2 3.7-50.6-9.1-55-13.9-4.6-5-5.3-5.3-7-4.3-2.8 1.5-1 6 0 8.6 2.6 6.8 13.3 18.8 31.4 24.7 16 5.2 54.9 8.1 102-10.1 52.7-20.4 93.9-77.1 81.8-124.6C330.7 2 250.7-13.9 175 13 130 29 81.2 54.2 46.1 87 4.4 126-2.2 159.9.5 174.1c9.7 50.4 79.2 83.2 107 107.5-1.4.8-2.7 1.5-3.8 2.1-13.9 6.9-66.9 34.6-80.1 63.9-15 33.2 2.4 57 13.9 60.2 35.7 9.9 72.4-7.9 92.1-37.3 19.7-29.4 17.3-67.6 8.2-85.1-.1-.2-.2-.4-.4-.6 3.6-2.1 7.3-4.3 10.9-6.4 7.1-4.2 14.1-8.1 20.1-11.3-3.4 9.3-5.9 20.4-7.1 36.4-1.5 18.8 6.2 43.2 16.3 52.8 4.5 4.2 9.8 4.3 13.2 4.3 11.8 0 17.1-9.8 23-21.4 7.2-14.2 13.7-30.7 13.7-30.7s-8.1 44.6 13.9 44.6c8 0 16.1-10.4 19.7-15.7v.1s.2-.3.6-1l1.3-2.1v-.2c3.2-5.6 10.4-18.3 21.1-39.4 13.8-27.2 27.1-61.2 27.1-61.2s1.2 8.3 5.3 22.1c2.4 8.1 7.4 17 11.4 25.6-3.2 4.5-5.2 7-5.2 7l.1.1c-2.6 3.4-5.4 7.1-8.5 10.7-10.9 13-23.9 27.9-25.7 32.2-2.1 5.1-1.6 8.8 2.4 11.8 2.9 2.2 8.1 2.5 13.4 2.2 9.8-.7 16.7-3.1 20.1-4.6 5.3-1.9 11.5-4.8 17.3-9.1 10.7-7.9 17.2-19.2 16.6-34.1-.3-8.2-3-16.4-6.3-24.1 1-1.4 1.9-2.8 2.9-4.2 16.9-24.7 30-51.8 30-51.8s1.2 8.3 5.3 22.1c2 7 6.1 14.6 9.7 22-15.9 12.9-25.7 27.9-29.2 37.7-6.3 18.2-1.4 26.4 7.9 28.3 4.2.9 10.2-1.1 14.6-3a66.5 66.5 0 0 0 18.5-9.5c10.7-7.9 21-18.9 20.4-33.8-.3-6.8-2.1-13.5-4.6-20 13.5-5.6 30.9-8.7 53.1-6.1 47.6 5.6 57 35.3 55.2 47.8-1.8 12.5-11.8 19.3-15.1 21.4-3.3 2.1-4.4 2.8-4.1 4.3.4 2.2 2 2.1 4.8 1.7 3.9-.7 25-10.1 25.9-33.1 1.5-29.4-26.5-61.5-76-61.2zM104.2 359.8C88.4 377 66.4 383.5 56.9 378c-10.2-5.9-6.2-31.3 13.2-49.5 11.8-11.1 27-21.4 37.1-27.7 2.3-1.4 5.7-3.4 9.8-5.9.7-.4 1.1-.6 1.1-.6l2.4-1.5c7.1 26 .3 48.9-16.3 67zm115-78.2c-5.5 13.4-17 47.7-24 45.8-6-1.6-9.7-27.6-1.2-53.3 4.3-12.9 13.4-28.3 18.7-34.3 8.6-9.6 18.1-12.8 20.4-8.9 2.9 5.1-10.5 42.3-13.9 50.7zm94.9 45.4c-2.3 1.2-4.5 2-5.5 1.4-.7-.4 1-2 1-2s11.9-12.8 16.6-18.6c2.7-3.4 5.9-7.4 9.3-11.9v1.3c0 15.3-14.8 25.6-21.4 29.8zm73.2-16.7c-1.7-1.2-1.4-5.2 4.3-17.7 2.2-4.9 7.4-13.1 16.3-21 1 3.2 1.7 6.3 1.6 9.2-.1 19.3-13.9 26.5-22.2 29.5z"
                  />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 256 154">
                  <defs />
                  <defs>
                    <linearGradient id="a" x1="-2.778%" x2="100%" y1="32%" y2="67.556%">
                      <stop offset="0%" stopColor="#2298BD" />
                      <stop offset="100%" stopColor="#0ED7B5" />
                    </linearGradient>
                  </defs>
                  <path fill="url(#a)" d="M128 0C93.867 0 72.533 17.067 64 51.2 76.8 34.133 91.733 27.733 108.8 32c9.737 2.434 16.697 9.499 24.401 17.318C145.751 62.057 160.275 76.8 192 76.8c34.133 0 55.467-17.067 64-51.2-12.8 17.067-27.733 23.467-44.8 19.2-9.737-2.434-16.697-9.499-24.401-17.318C174.249 14.743 159.725 0 128 0zM64 76.8C29.867 76.8 8.533 93.867 0 128c12.8-17.067 27.733-23.467 44.8-19.2 9.737 2.434 16.697 9.499 24.401 17.318C81.751 138.857 96.275 153.6 128 153.6c34.133 0 55.467-17.067 64-51.2-12.8 17.067-27.733 23.467-44.8 19.2-9.737-2.434-16.697-9.499-24.401-17.318C110.249 91.543 95.725 76.8 64 76.8z" />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 70">
                  <defs />
                  <g fill="#0AB3AF" fill-rule="nonzero">
                    <path d="M35.419 32.333H22V39h13.096c.774 0 1.484-.333 2.064-.867C37.676 37.6 38 36.8 38 35.8c.019-.858-.23-1.7-.71-2.4-.516-.667-1.096-1.067-1.87-1.067zm.451-8.066c.58-.4.839-1.267.839-2.4 0-1-.258-1.734-.71-2.2-.451-.4-1.032-.667-1.677-.667H22v6h12.064c.645 0 1.29-.333 1.806-.733z" />
                    <path d="M58.307 0h-54.2C2.381 0 1 1.365 1 3.002v53.626c0 1.637 1.38 2.66 3.038 2.66h8.01V70l9.942-10.643h36.317c1.657 0 2.693-1.024 2.693-2.73V3.07C61 1.433 59.964.068 58.238.068l.07-.068zm-9.114 43.46c-.69 1.228-1.726 2.252-2.969 3.002-1.311.819-2.761 1.57-4.418 1.91-1.658.41-3.453.75-5.317.75H12.047V10.917h27.756c1.381 0 2.555.273 3.66.887a9.496 9.496 0 012.761 2.183 10.158 10.158 0 012.348 6.618c0 1.774-.483 3.48-1.381 5.117a8.596 8.596 0 01-4.143 3.684c2.21.614 3.936 1.706 5.248 3.275 1.243 1.638 1.864 3.753 1.864 6.414 0 1.705-.345 3.138-1.036 4.366h.07z" />
                  </g>
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" viewBox=".243 .265 243.323 243.581">
                  <defs />
                  <g fill="#8e75ff" fill-rule="evenodd">
                    <path d="M161.893 165.833v-78.73a5.077 5.077 0 00-5.077-5.076H78.178V.76h159.815a5.077 5.077 0 015.078 5.077v159.996z" />
                    <path d="M78.178.76v81.267H3.124a2.539 2.539 0 01-1.796-4.333zm83.715 240.206v-75.133h81.178l-76.844 76.927a2.539 2.539 0 01-4.334-1.794zM78.178 82.027h81.176a2.539 2.539 0 012.539 2.538v81.268H83.255a5.077 5.077 0 01-5.077-5.077z" opacity=".405" />
                  </g>
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 256 289">
                  <defs />
                  <path fill="#FAE501" d="M87.333 200.777c-15.306-14.406-24.309-34.213-24.309-56.722s9.003-42.316 23.409-56.722c12.605-12.604 12.605-32.412 0-45.017-12.605-12.605-32.412-12.605-45.017 0C16.206 68.426 0 104.44 0 144.055s16.206 75.629 42.316 101.739c12.605 12.605 32.413 12.605 45.017 0 11.705-12.605 11.705-32.413 0-45.017z" />
                  <path fill="#4FB5E1" d="M87.333 87.333c14.406-15.306 34.213-24.309 56.722-24.309s42.316 9.003 56.722 23.409c12.604 12.605 32.412 12.605 45.017 0 12.605-12.605 12.605-32.412 0-45.017C219.684 16.206 183.67 0 144.055 0S68.426 16.206 42.316 42.316c-12.605 12.605-12.605 32.413 0 45.017 12.605 11.705 32.413 11.705 45.017 0z" />
                  <path fill="#F05751" d="M200.777 200.777c-14.406 15.305-34.213 24.309-56.722 24.309s-42.316-9.004-56.722-23.41c-12.604-12.604-32.412-12.604-45.017 0-12.605 12.606-12.605 32.413 0 45.018 26.11 25.21 62.124 41.416 101.739 41.416s75.629-16.206 101.739-42.316c12.605-12.605 12.605-32.413 0-45.017-12.605-11.705-32.413-11.705-45.017 0z" />
                  <circle cx="64.825" cy="64.825" r="31.512" fill="#0681B6" />
                  <circle cx="64.825" cy="223.285" r="31.512" fill="#CD4739" />
                </Svg>
              </Grid.Column>
              <Grid.Column mobile={8} tablet={8} computer={4}>
                <Svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" viewBox="0 0 256 256">
                  <defs />
                  <path fill="#25C7B7" d="M153.094 165.679l-62.785-13.12a14.631 14.631 0 01-.876 1.475l57.157 83.378 3.448-3.444 9.724-60.47a11.458 11.458 0 01-6.668-7.82zM130.19 83.605c-2.352 3.608-6.412 5.996-11.036 5.996-.712 0-1.404-.072-2.084-.18l-28.633 44.801 76.498-32.92c-.024-.308-.092-.596-.092-.912 0-.644.088-1.268.192-1.884l-34.845-14.9zm2.08-8.164l37.065 15.848a11.447 11.447 0 013.976-2.008l6.092-37.88-23.209-23.209L130.07 69.07a13.013 13.013 0 012.2 6.372zm77.665 6.492l-23.26-23.264-5.056 31.408a11.628 11.628 0 013.396 2.584l24.92-10.728zm-55.729 75.473a11.355 11.355 0 019.089-5.844l6.68-41.548c-.524-.348-.992-.764-1.452-1.192l-76.938 33.112c.196.804.332 1.624.396 2.476l62.225 12.996zm62.065-69.133l-26.912 11.58 66.401 28.389.24-.24-39.729-39.729zm-48.092 85.35l-8.088 50.284 46.964-46.964-33.828-7.064a11.366 11.366 0 01-5.048 3.744zm-91.286-12.928c-1.7 0-3.328-.292-4.852-.809l-15.6 24.413-6.028-6.024 14.776-23.12a16.066 16.066 0 01-1.02-1.417l-26.768 11.525-6.345-6.345 29.3-12.612L7.385 135.25.14 128.002l2.292-2.292 61.085 12.752a14.981 14.981 0 012.668-3.616L36.537 91.601l5.988-5.988L73.5 130.798a15.283 15.283 0 013.392-.396c1.308 0 2.576.184 3.788.496l28.985-45.353a13.126 13.126 0 01-3.676-9.116c0-1.04.132-2.048.36-3.016l-36.16-15.46 6.343-6.344 34.26 14.652a13.12 13.12 0 0112.653-2.268l26.724-41.825L128.002 0 0 128.002l128.002 128.002 12.596-12.596-57.585-84.01a15.117 15.117 0 01-6.12 1.297zm101.23-48.89l-6.796 42.237a11.359 11.359 0 014.196 7.813l38.572 8.052 35.32-35.32-63.752-27.257a11.508 11.508 0 01-7.54 4.476z" />
                </Svg>
              </Grid.Column>
            </Grid>
          </Container>
        </Container>

        <Container fluid style={{ backgroundColor: "#fff" }}>
          <Container>
            <h2>{frRecomtitle}</h2>
            <Slider {...settings}>
              {[
                frHomepage.node.recommendations.map((recommandation, i) => (
                  <Recommandation className="C--recommandations">
                    <Item.Group unstackable>
                      <Item>
                        <Item.Image
                          size="tiny"
                          style={{ maxWidth: 80 }}
                          src={recommandation.photo.sizes.src}
                          alt={recommandation.author}
                        />
                        <Item.Content>
                          <Item.Header>
                            "{recommandation.content.content}"
                          </Item.Header>
                          <Item.Description>
                            {recommandation.author} - {recommandation.position}
                          </Item.Description>
                          <a href={`${recommandation.link}`}>
                            {frRecomLink}
                            {recommandation.author.split(" ", 1)}
                          </a>
                        </Item.Content>
                      </Item>
                    </Item.Group>
                  </Recommandation>
                ))
              ]}
            </Slider>
          </Container>
        </Container>
      </div>
    );

    const LASTARTICLE = ({ node }) => (
      <AsideLastArticle>
        <h2>{frDernierArticle}</h2>
        <LastArticleContainer>
          <Link to={`/blogue/${lastArticle.slug}/`}>
            <Card>
              <Img
                src={lastArticle.media.sizes.src}
                style={{
                  margin: 0
                }}
                sizes={lastArticle.media.sizes}
              />
              <Card.Content>
                <Card.Header>{lastArticle.title}</Card.Header>
                <Card.Meta>{lastArticle.createdAt}</Card.Meta>
                <Card.Description>{lastArticle.description}</Card.Description>
              </Card.Content>
              <Card.Content extra>
                <span className="ui fluid icon right labeled button">
                  {frLireArticle}
                </span>
              </Card.Content>
            </Card>
          </Link>
        </LastArticleContainer>
      </AsideLastArticle>
    );

    return (
      <div>
        <Helmet>
          <title>{config.siteTitle}</title>
        </Helmet>
        <HOMEPAGE />
      </div>
    );
  }
}

IndexPage.propTypes = propTypes;

export default IndexPage;

export const pageQuery = graphql`
  query PageQuery {
    fr: allContentfulHomepage(filter: { node_locale: { eq: "fr-CA" } }) {
      edges {
        node {
          id
          name
          content {
            content
          }
          recommendations {
            id
            author
            content {
              content
            }
            link
            position
            photo {
              sizes(maxWidth: 100) {
                base64
                aspectRatio
                src
                srcSet
                sizes
              }
            }
          }
        }
      }
    }
    bg: allContentfulAsset(filter: { id: { eq: "c5PxvSEWkBqoswQKa0ioIAq" } }) {
      edges {
        node {
          id
          sizes(maxWidth: 4000) {
            base64
            aspectRatio
            src
            srcSet
            sizes
          }
        }
      }
    }
    lastFr: allContentfulArticles(
      filter: { node_locale: { eq: "fr-CA" } }
      sort: { fields: [createdAt], order: DESC }
      limit: 1
    ) {
      edges {
        node {
          id
          title
          description
          slug
          createdAt(formatString: "DD MMM, YYYY")
          media {
            sizes(maxWidth: 100) {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js